import React from 'react';

import wwwApconCom from '../www.apcon.com';
import { getTechnologiesByTitle } from './technologies';

const industries = [
  {
    id: 1,
    title: 'Finance',
    description:
      'APCON’s visibility solutions help financial institutions and insurance companies improve security, compliance, and operational efficiency.',
    longDescription: (
      <>
        <p className=" ">
          In today&apos;s financial world, IT and security professionals face
          relentless challenges, battling threats on multiple fronts while
          safeguarding customer trust. Speed, accuracy, and data privacy are the
          backbone of any financial institution’s reputation. With cyberattacks
          becoming more frequent and complex, network security teams need
          cutting-edge solutions to protect massive amounts of sensitive data.
          That’s where APCON comes in.
        </p>
        <p className="mt-4">
          {' '}
          Our advanced services, like Protocol Stripping, Deduplication, and
          Packet Slicing, help streamline and de - personalize data—ensuring you
          meet even the toughest privacy and accuracy standards without
          compromising performance.
        </p>
      </>
    ),
    icon: 'mdi:currency-usd',
    url: wwwApconCom.solutions.finance,
    technologies: getTechnologiesByTitle([
      'Deep Packet Inspection',
      'Traffic Shaping',
      'Pattern Matching',
      'Packet Filtering',
      'Packet Slicing',
      'Packet Sniffing',
    ]),
  },
  {
    id: 2,
    title: 'Government',
    description:
      'APCON’s visibility solutions help government agencies, military organizations, and law enforcement agencies improve security, compliance, and operational efficiency.',
    longDescription: (
      <>
        <p className=" ">
          Governments and military organizations face unique security
          challenges, including the need to protect sensitive information while
          maintaining high performance and visibility. APCON’s visibility
          solutions help government agencies, military organizations, and law
          enforcement agencies improve security, compliance, and operational
          efficiency.
        </p>
      </>
    ),
    icon: 'mdi:library',
    url: wwwApconCom.solutions.government,
    technologies: getTechnologiesByTitle([
      'Application Filtering',
      'Deep Packet Inspection',
      'Tunneling',
      'NetFlow Generation',
      'Distributed Load Balancing',
    ]),
  },
  {
    id: 3,
    title: 'Academia',
    description:
      'APCON’s visibility solutions help academia and municipalities improve security, compliance, and operational efficiency.',
    longDescription:
      'State, local, and academic institutions are responsible for serving their constituents and students, including protecting their data. In organizations such as these, a single network vulnerability is all an attacker needs to steal critical data.',
    icon: 'mdi:school',
    url: wwwApconCom.solutions.stateLocalEducation,
    technologies: getTechnologiesByTitle([
      'Traffic Shaping',
      'Pattern Matching',
      'Header Stripping',
      'Network Data Deduplication',
      'Application Analytics',
    ]),
  },
  {
    id: 4,
    title: 'Healthcare',
    description:
      'APCON’s visibility solutions help healthcare and pharmaceutical companies improve security, compliance, and operational efficiency.',
    longDescription:
      'The medical and pharmaceutical industries are responsible for keeping people healthy and enhancing the patient experience. At the same time, healthcare IT teams are under siege due to increased cyber threats, mergers and acquisitions, proliferating electronic health records, and industry regulations.',
    icon: 'mdi:flask',
    url: wwwApconCom.solutions.healthcare,
    technologies: getTechnologiesByTitle([
      'Deep Packet Inspection',
      'Packet Filtering',
      'Packet Slicing',
      'Application Analytics',
    ]),
  },
  {
    id: 5,
    title: 'Transportation',
    description:
      'APCON’s visibility solutions help aviation, aerospace, transportation, and shipping companies improve security, compliance, and operational efficiency.',
    longDescription: (
      <>
        <p>
          Find out how APCON provides better visibility solutions for the vast
          networks driving the world&apos;s top aeronautical, territorial &
          global shipping, and transportation enterprises.
        </p>
      </>
    ),
    icon: 'mdi:truck',
    url: wwwApconCom.solutions.aerospaceTransportation,
    technologies: getTechnologiesByTitle([
      'Application Filtering',
      'Tunneling',
      'Distributed Load Balancing',
      'Network Data Deduplication',
    ]),
  },
  {
    id: 6,
    title: 'Energy',
    description:
      'APCON’s visibility solutions help energy production, manufacturing, and utilities companies improve security, compliance, and operational efficiency.',
    longDescription: (
      <>
        <p>
          Large energy providers remain primary targets for hackers bent on
          capitalizing on the vulnerabilities found throughout this
          industry&apos;s large attack surfaces. Network uptime is paramount for
          the power grid and public utilities potentially serving millions of
          customers, and IT professionals make their networks more resilient
          with APCON&apos;s deep observability solutions.
        </p>
      </>
    ),
    icon: 'mdi:lightbulb',
    url: wwwApconCom.solutions.energyIndustry,
    technologies: getTechnologiesByTitle([
      'Deep Packet Inspection',
      'Pattern Matching',
      'Packet Filtering',
    ]),
  },
  {
    id: 7,
    title: 'Software',
    description:
      'APCON’s visibility solutions help software, telecom, and service providers improve security, compliance, and operational efficiency.',
    longDescription: (
      <>
        <p>
          With exponential growth in recent years, service providers are
          experiencing a whirlwind of change in network technology. The
          unprecedented volume of data running through data centers demands
          meticulous network scrutiny and caution.
        </p>
      </>
    ),
    icon: 'mdi:code-tags',
    url: wwwApconCom.solutions.softwareServices,
    technologies: getTechnologiesByTitle([
      'Application Filtering',
      'Traffic Shaping',
      'Packet Slicing',
      'Network Data Deduplication',
      'Application Analytics',
    ]),
  },
  {
    id: 8,
    title: 'Entertainment',
    description:
      'APCON’s visibility solutions help entertainment and travel providers improve security, compliance, and operational efficiency.',
    longDescription:
      'Travel, entertainment, and broadcasting companies often have very complex networks running on systems that do not always communicate well with each other. Faced with this level of complexity, IT teams are always seeking better solutions including network packet brokers and monitoring software that can support quicker, more efficient diagnosis of problems within these networks.',
    icon: 'mdi:film',
    url: wwwApconCom.solutions.entertainmentTravel,
    technologies: getTechnologiesByTitle([
      'Deep Packet Inspection',
      'Pattern Matching',
    ]),
  },
];

function getIndustryById(id) {
  return industries.find(industry => industry.id === id);
}
function getIndustriesByIds(ids) {
  return industries.filter(industry => ids.includes(industry.id));
}

export default industries;
export { getIndustriesByIds, getIndustryById };
